export default __webpack_public_path__ + "static/models-2-5d8224212996bfc391ef9df4eb0b5b46.mp4";